import router from "../router";

export default function setup(axios) {
    axios.interceptors.request.use(function (config) {
        const token = localStorage.getItem('authToken');
        config.headers.Authorization = 'Bearer ' + token;
        return config;
    }, function (error) {
        return Promise.reject(error);
    });
    axios.interceptors.response.use(
        (response) => {
            return Promise.resolve(response);
        },
        (error) => {
            switch (error.response.status) {
                case 401:
                {
                    router.push({ name: 'login' });
                    //store.commit('auth/SET_CURRENT_USER', null);
                    //router.push({ name: "login" });
                }
                break;                
            }

            return Promise.reject(error);
        }
    );
}